import React, { useMemo } from 'react';
import { KeycloakProvider } from '@react-keycloak/web';

import { keycloak, removeKcTokenLocalStorage } from './keycloak';

const CustomKeycloakProvider = ({ children }) => {
  const initConfig = useMemo(() => {
    const savedToken = localStorage.getItem('kc_token');
    const savedRefreshToken = localStorage.getItem('kc_refreshToken');
    const savedIdToken = localStorage.getItem('kc_idToken');

    if (savedToken) {
      return {
        token: savedToken,
        refreshToken: savedRefreshToken,
        idToken: savedIdToken,
        onLoad: undefined,
        checkLoginIframe: false,
      };
    }

    return {
      onLoad: "check-sso",
      silentCheckSsoRedirectUri: window.location.origin + "/silent-check-sso.html",
      checkLoginIframe: false,
    };
  }, []);

  const onKeycloakEvent = (event) => {
    if ((event === 'onReady' || event === 'onAuthSuccess') && keycloak.authenticated)
      removeKcTokenLocalStorage();
  };

  return (
    <KeycloakProvider 
      keycloak={keycloak} 
      initConfig={initConfig} 
      onEvent={onKeycloakEvent}
    >
      {children}
    </KeycloakProvider>
  );
};

export default CustomKeycloakProvider;